import { USER_GET_TOKEN_SUCCESS, USER_GET_TOKEN_FAIL, USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAIL, MENTOR_REGISTER_REQUEST, MENTOR_REGISTER_SUCCESS, MENTOR_REGISTER_FAIL, STUDENT_REGISTER_REQUEST, STUDENT_REGISTER_SUCCESS, STUDENT_REGISTER_FAIL, USER_PROFILE_REQUEST, USER_PROFILE_FAIL, USER_PROFILE_SUCCESS, USER_PROFILE_UPDATE_REQUEST, USER_PROFILE_UPDATE_FAIL, USER_PROFILE_UPDATE_SUCCESS, USER_LOGOUT_REQUEST, USER_LOGOUT_SUCCESS, USER_LOGOUT_FAIL } from './user.constants'

export const userLoginReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_GET_TOKEN_SUCCESS:
            return { ...state, token: action.payload }
        case USER_GET_TOKEN_FAIL:
            return { ...state, error: action.payload }
        case USER_LOGIN_REQUEST:
            return { loading: true }
        case USER_LOGIN_SUCCESS:
            return {
                loading: false,
                success: true,
            }
        case USER_LOGIN_FAIL:
            return {
                loading: false,
                success: false,
                error: action.payload
            }
        case USER_LOGOUT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case USER_LOGOUT_SUCCESS:
            return {
                loading: false,
                logoutSuccess: true,
                token: null
            }
        case USER_LOGOUT_FAIL:
            return {
                loading: false,
                success: false,
                error: action.payload
            }
        default:
            return state
    }
}

export const mentorRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case MENTOR_REGISTER_REQUEST:
            return { loading: true };
        case MENTOR_REGISTER_SUCCESS:
            return { loading: false, success: true };
        case MENTOR_REGISTER_FAIL:
            return { loading: false, success: false, error: action.payload };
        default:
            return state;
    }
};

export const studentRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case STUDENT_REGISTER_REQUEST:
            return { loading: true };
        case STUDENT_REGISTER_SUCCESS:
            return { loading: false, success: true };
        case STUDENT_REGISTER_FAIL:
            return { loading: false, success: false, error: action.payload };
        default:
            return state;
    }
};

export const userProfileReducer = (state = { user: {} }, action) => {
    switch (action.type) {
        case USER_PROFILE_REQUEST:
            return { ...state, loading: true }
        case USER_PROFILE_SUCCESS:
            return {
                loading: false,
                user: action.payload
            }
        case USER_PROFILE_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        default:
            return state
    }
}

export const userProfileUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_PROFILE_UPDATE_REQUEST:
            return { ...state, loading: true }
        case USER_PROFILE_UPDATE_SUCCESS:
            return {
                loading: false,
                success: true,
                userProfileInfo: action.payload
            }
        case USER_PROFILE_UPDATE_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        default:
            return state
    }
}
